(function () {
  // =========================
  // selectors & constants
  // =========================
  const QV_OPEN_SELECTOR = '.product__quick_view, .js-open-quick-view, [data-action="quick-view"]';
  const QUICK_ADD_SELECTOR = [
    '.deals--product-cart-button',
    '.product--card-list-button',
    '.product__card--cart-btn',
    '.js-quick-add',
    '[data-quick-add]',
    '[data-action="add-to-cart"]'
  ].join(',');

  const WRAPPER_ID = 'quickViewWrapper';
  const OVERLAY_SELECTOR = '.quick-view-overlay';
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  // tiny helpers
  const $  = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));
  const sleep = (ms)=>new Promise(r=>setTimeout(r,ms));
  const esc = window.CSS && CSS.escape ? CSS.escape : (s)=>String(s).replace(/["\\]/g, '\\$&');

  // =========================
  // variant helpers
  // =========================
  function getVariantsArray(root) {
    const s = root.querySelector('script[type="application/json"][data-variant]');
    if (!s) return null;
    try {
      const parsed = JSON.parse(s.textContent.trim());
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.variants)) return parsed.variants;
      return null;
    } catch { return null; }
  }
  function findVariantById(variants, id) {
    const sid = String(id);
    return Array.isArray(variants) ? variants.find(v => String(v.id) === sid) : null;
  }
  function findVariantByOptions(variants, values) {
    if (!Array.isArray(variants)) return null;
    return variants.find(v =>
      (!values[0] || v.option1 === values[0]) &&
      (!values[1] || v.option2 === values[1]) &&
      (!values[2] || v.option3 === values[2])
    ) || null;
  }
  function getSelectedOptions(root) {
    const out = [null, null, null];
    [1,2,3].forEach(pos => {
      const r = root.querySelector(`input[type="radio"][data-option-position="${pos}"]:checked`);
      if (r) out[pos-1] = r.value;
      const s = root.querySelector(`select[data-option-position="${pos}"]`);
      if (s && s.value) out[pos-1] = s.value;
    });
    $$('fieldset[class*="variant--swatch-option"]', root).forEach(fs => {
      const m = fs.className.match(/variant--swatch-option(\d)/);
      if (!m) return;
      const pos = Number(m[1])-1;
      const r = fs.querySelector('input[type="radio"][name^="options["]:checked');
      if (r) { out[pos] = r.value; return; }
      const s = fs.querySelector('select[name^="options["]');
      if (s && s.value) out[pos] = s.value;
    });
    return out;
  }
  function ensureOptionPositions(root) {
    $$('fieldset[class*="variant--swatch-option"]', root).forEach(fs => {
      const m = fs.className.match(/variant--swatch-option(\d)/);
      if (!m) return;
      const pos = Number(m[1]);
      $$('input[type="radio"][name^="options["]', fs).forEach(r => r.setAttribute('data-option-position', String(pos)));
      $$('select[name^="options["]', fs).forEach(s => s.setAttribute('data-option-position', String(pos)));
    });
  }
  function setOptionInputsForVariant(root, variant) {
    if (!variant) return;
    const opts = [variant.option1, variant.option2, variant.option3];
    ensureOptionPositions(root);
    opts.forEach((val, idx) => {
      if (!val) return;
      $$( `input[type="radio"][data-option-position="${idx+1}"]`, root ).forEach(r => { r.checked = (r.value === val); });
      const r = root.querySelector(`input[type="radio"][data-option-position="${idx+1}"][value="${esc(val)}"]`);
      if (r) r.dispatchEvent(new Event('change', { bubbles: true }));
      const sel = root.querySelector(`select[data-option-position="${idx+1}"]`);
      if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      const fs = root.querySelector(`fieldset.variant--swatch-option${idx+1}`);
      if (fs) {
        const r2 = fs.querySelector(`input[type="radio"][name^="options["][value="${esc(val)}"]`);
        if (r2) { r2.checked = true; r2.dispatchEvent(new Event('change', { bubbles: true })); }
        const s2 = fs.querySelector('select[name^="options["]');
        if (s2) { s2.value = val; s2.dispatchEvent(new Event('change', { bubbles: true })); }
      }
    });
  }
  function setVariantIdFields(root, variantId) {
    if (!variantId) return;
    $$('input[name="id"]', root).forEach(inp => {
      inp.value = String(variantId);
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const sel = root.querySelector('select[name="id"]');
    if (sel) { sel.value = String(variantId); sel.dispatchEvent(new Event('change', { bubbles: true })); }
    $$('a[href^="/products/"]', root).forEach(a => {
      try {
        const u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.set('variant', String(variantId));
        a.setAttribute('href', u.pathname + u.search);
      } catch {}
    });
  }

  // =========================
  // SCROLL-BASED GALLERY FOCUS (met src-fallback)
  // =========================
  function normalizeSrc(src) {
    if (!src) return '';
    try {
      const u = new URL(src, location.origin);
      const path = u.pathname.replace(/_(\d+x\d+|\d+x|x\d+)\.(jpg|jpeg|png|webp|gif)$/i, '.$2');
      return (u.origin + path).toLowerCase();
    } catch {
      return String(src).toLowerCase();
    }
  }
  function srcBasename(src) {
    const s = normalizeSrc(src);
    const m = s.match(/\/([^\/?#]+)\.(jpg|jpeg|png|webp|gif)(\?|#|$)/i);
    return m ? m[1] : s;
  }
  function slideForMediaId(root, mediaId) {
    if (!mediaId) return null;
    return root.querySelector(`.quickView_media_gallery .quick--view-slide-item[data-media-id="${mediaId}"]`);
  }
  function slideByImageSrc(root, imageSrc) {
    if (!imageSrc) return null;
    const base = srcBasename(imageSrc);
    const candidates = $$('.quickView_media_gallery .quick--view-slide-item', root);
    for (const li of candidates) {
      const img = li.querySelector('img');
      if (!img) continue;
      const s = normalizeSrc(img.currentSrc || img.src || img.getAttribute('src'));
      if (s.includes(base)) return li;
    }
    return null;
  }
  function markActiveSlide(gallery, slide) {
    if (!gallery || !slide) return;
    gallery.querySelectorAll('.quick--view-slide-item.is-active').forEach(el=>el.classList.remove('is-active'));
    slide.classList.add('is-active');
  }
  function scrollSlideIntoView(gallery, slide, smooth=false) {
    if (!gallery || !slide) return;
    const left = slide.offsetLeft - parseInt(getComputedStyle(gallery).paddingLeft || '0', 10);
    gallery.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
  }
  async function focusFeaturedMedia(root, variant, smooth=false) {
    if (!variant) return;

    // 1) haal media-id als die bestaat
    const mediaObj = variant.featured_media || variant.featured_image || null;
    const mediaId = mediaObj && (mediaObj.id || mediaObj.media_id);
    const imageSrc = (variant.featured_image && (variant.featured_image.src || variant.featured_image.url))
                  || (mediaObj && (mediaObj.src || mediaObj.original_src || (mediaObj.preview_image && mediaObj.preview_image.src)))
                  || null;

    const gallery = root.querySelector('.quickView_media_gallery');
    if (!gallery) return;

    // 2) probeer eerst data-media-id
    let slide = slideForMediaId(root, mediaId);

    // 3) zo niet: match op filename van featured_image.src
    if (!slide && imageSrc) slide = slideByImageSrc(root, imageSrc);

    // 4) scroll + markeer
    if (slide) {
      markActiveSlide(gallery, slide);
      scrollSlideIntoView(gallery, slide, smooth);
    }
    // geen hard swap nodig in jouw setup: de slide is het beeld
  }

  function hydrateVariantUI(root, variantId) {
    const variants = getVariantsArray(root);
    if (!variants) return;
    const v = findVariantById(variants, variantId);
    if (!v) return;
    setOptionInputsForVariant(root, v);
    setVariantIdFields(root, v.id);
    focusFeaturedMedia(root, v, false);
  }

  function bindVariantChangeInsideModal(root) {
    root.addEventListener('change', async (e) => {
      const t = e.target;
      const isOptionInput =
        t.matches('input[type="radio"][name^="options["], select[name^="options["]') ||
        t.hasAttribute('data-option-position');
      if (!isOptionInput) return;

      const variants = getVariantsArray(root);
      if (!variants) return;

      const values = getSelectedOptions(root);
      const v = findVariantByOptions(variants, values);
      if (!v) return;

      setVariantIdFields(root, v.id);
      await focusFeaturedMedia(root, v, true);

      try { root.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: v } })); } catch {}
    }, true);
  }

  // =========================
  // quick view open/close
  // =========================
  function buildQuickViewUrlFromBtn(btn) {
    let raw = btn.getAttribute('data-url');
    if (!raw || raw === '#') {
      const handle = btn.getAttribute('data-product-handle');
      raw = handle ? `/products/${handle}?view=quickview` : '';
    }
    if (!raw) return null;
    const v = (btn.getAttribute('data-variant-id') || '').trim();
    try {
      const u = new URL(raw, location.origin);
      if (v) u.searchParams.set('variant', v);
      return u.pathname + u.search;
    } catch { return null; }
  }
  async function fetchQuickView(url) {
    const res = await fetch(url, { headers: { 'X-Requested-With':'XMLHttpRequest' }, credentials:'same-origin' });
    if (!res.ok) throw new Error('Quick view request failed');
    return res.text();
  }
  function openWrapper() {
    const wrap = document.getElementById(WRAPPER_ID);
    if (!wrap) return;
    wrap.classList.add('show__modal');
    const overlay = $(OVERLAY_SELECTOR);
    if (overlay) overlay.classList.add('show__modal');
    document.documentElement.classList.add('no-scroll--qv');
  }
  function closeWrapper() {
    const wrap = document.getElementById(WRAPPER_ID);
    if (!wrap) return;
    wrap.classList.remove('show__modal');
    const overlay = $(OVERLAY_SELECTOR);
    if (overlay) overlay.classList.remove('show__modal');
    document.documentElement.classList.remove('no-scroll--qv');
  }
  function rebindQuickViewClosers() {
    const wrap = document.getElementById(WRAPPER_ID);
    if (!wrap) return;
    const overlay = $(OVERLAY_SELECTOR);
    if (overlay) overlay.addEventListener('click', (e) => { e.preventDefault(); closeWrapper(); });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest(QUICK_ADD_SELECTOR)) return;
    const btn = e.target.closest(QV_OPEN_SELECTOR);
    if (!btn) return;

    e.preventDefault(); e.stopPropagation();
    (async () => {
      const url = buildQuickViewUrlFromBtn(btn);
      const wrap = document.getElementById(WRAPPER_ID);
      if (!url || !wrap) return;

      wrap.innerHTML = '<div data-quick-view style="min-height:120px;display:flex;align-items:center;justify-content:center;padding:2rem;"><div class="loading-overlay__spinner"><svg class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>';
      openWrapper();

      try {
        const html = await fetchQuickView(url);
        wrap.innerHTML = html;

        // inline scripts opnieuw uitvoeren
        wrap.querySelectorAll('script').forEach(old => {
          const s=document.createElement('script');
          [...old.attributes].forEach(a=>s.setAttribute(a.name,a.value));
          s.textContent = old.textContent;
          old.replaceWith(s);
        });

        ensureOptionPositions(wrap);
        bindVariantChangeInsideModal(wrap);

        // initial variant
        let initialVariantId = (btn.getAttribute('data-variant-id') || '').trim();
        if (!initialVariantId) {
          try {
            const u = new URL(url, location.origin);
            const qp = u.searchParams.get('variant');
            if (qp) initialVariantId = qp;
          } catch {}
        }
        if (!initialVariantId) {
          const vs = getVariantsArray(wrap);
          if (vs && vs.length) {
            const first = vs.find(v => v.available) || vs[0];
            initialVariantId = String(first.id);
          }
        }

        await sleep(20);
        if (initialVariantId) hydrateVariantUI(wrap, initialVariantId);

        rebindQuickViewClosers();
      } catch {
        wrap.innerHTML = '<div style="padding:2rem;">Quick view kon niet geladen worden.</div>';
      }
    })();
  }, true);

  // closers
  document.addEventListener('click', (e) => {
    const closeEl = e.target.closest(
      '[data-close-quickview], .quick-view__close, .quickViewClose, .quick-view-close, .modal__close, .drawer__close, [aria-label="Close"], [aria-label="Sluiten"], button[aria-label*="Close"], button[aria-label*="close"], #close_modal, .quick__view_btn_close, quick-view-close button'
    );
    if (closeEl) { e.preventDefault(); e.stopPropagation(); closeWrapper(); }
  }, true);
  document.addEventListener('click', (e) => {
    const wrap = document.getElementById(WRAPPER_ID);
    if (!wrap || wrap.classList.contains('quick__shop--drawer')) return;
    if (!wrap.classList.contains('show__modal')) return;
    if (e.target === wrap) { e.preventDefault(); closeWrapper(); }
  }, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeWrapper(); });
  document.addEventListener('DOMContentLoaded', () => rebindQuickViewClosers());

  // =========================
  // QUICK ADD (zoals je werkende flow)
  // =========================
  function resolveHandleFromBtn(btn) {
    let h = btn.getAttribute('data-product-handle') || btn.getAttribute('data-handle');
    if (h) return h;

    const cand = btn.getAttribute('data-url') || btn.getAttribute('data-product-url') || '';
    if (cand) {
      try {
        const u = new URL(cand, location.origin);
        const parts = u.pathname.split('/').filter(Boolean);
        const pIdx = parts.indexOf('products');
        if (pIdx >= 0 && parts[pIdx+1]) return parts[pIdx+1];
      } catch {}
    }

    const card = btn.closest('[data-product-handle], [data-handle], [data-product-url], .product-card, article, li, .grid__item');
    if (card) {
      h = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
      if (h) return h;
      const urlAttr = card.getAttribute('data-product-url');
      if (urlAttr) {
        try {
          const u = new URL(urlAttr, location.origin);
          const parts = u.pathname.split('/').filter(Boolean);
          const pIdx = parts.indexOf('products');
          if (pIdx >= 0 && parts[pIdx+1]) return parts[pIdx+1];
        } catch {}
      }
      const a = card.querySelector('a[href*="/products/"]');
      if (a) {
        try {
          const u = new URL(a.getAttribute('href'), location.origin);
          const parts = u.pathname.split('/').filter(Boolean);
          const pIdx = parts.indexOf('products');
          if (pIdx >= 0 && parts[pIdx+1]) return parts[pIdx+1];
        } catch {}
      }
    }
    return '';
  }
  function resolveVariantIdFromBtn(btn) {
    let id = (btn.getAttribute('data-variant-id') || '').trim();
    if (id) return id;
    const card = btn.closest('[data-product-id], [data-product-handle], .product-card, article, li, .grid__item') || document;
    const hidden = card && card.querySelector('input[name="id"]');
    if (hidden?.value) return hidden.value.trim();
    const json = card && card.querySelector('script[type="application/json"][data-variants], script[type="application/json"][data-variant]');
    if (json) {
      try {
        const parsed = JSON.parse(json.textContent.trim());
        const arr = Array.isArray(parsed) ? parsed : (parsed && parsed.variants ? parsed.variants : []);
        const first = Array.isArray(arr) ? (arr.find(v => v.available) || arr[0]) : null;
        if (first) return String(first.id);
      } catch {}
    }
    return '';
  }
  async function fetchDefaultVariantId(handle) {
    try {
      const res = await fetch(`${ROOT}products/${handle}.js`, { headers:{'Accept':'application/json'}, credentials:'same-origin' });
      if (!res.ok) return '';
      const p = await res.json();
      if (Array.isArray(p.variants) && p.variants.length) {
        const v = p.variants.find(v=>v.available) || p.variants[0];
        return String(v.id);
      }
      return '';
    } catch { return ''; }
  }
  async function ensureProxyQuickView(handle, variantIdMaybe) {
    const url = `/products/${handle}?view=quickview${variantIdMaybe ? `&variant=${encodeURIComponent(variantIdMaybe)}` : ''}`;
    const html = await fetchQuickView(url);
    let proxy = document.getElementById('qv-proxy-container');
    if (!proxy) {
      proxy = document.createElement('div');
      proxy.id = 'qv-proxy-container';
      proxy.setAttribute('aria-hidden', 'true');
      proxy.style.cssText = 'position:fixed;left:-99999px;top:-99999px;width:1px;height:1px;overflow:hidden;';
      document.body.appendChild(proxy);
    }
    proxy.innerHTML = html;
    const firstChild = proxy.firstElementChild || proxy;
    if (!firstChild.id) firstChild.id = 'qv-proxy-section';
    try { document.dispatchEvent(new CustomEvent('shopify:section:load', { detail:{ sectionId:firstChild.id } })); } catch {}
    proxy.querySelectorAll('script').forEach(old => {
      const s=document.createElement('script');
      [...old.attributes].forEach(a=>s.setAttribute(a.name,a.value));
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
    await sleep(30);
    const form = proxy.querySelector('form[data-type="add-to-cart-form"], product-form form');
    if (!form) throw new Error('Proxy product form niet gevonden');
    return { proxy, form };
  }
  function resolveVariantIdFromProxyForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);
    const sel = form.querySelector('select[name="id"]');
    if (sel && sel.value) return String(sel.value);
    const vjson = form.closest('#qv-proxy-container')?.querySelector('script[type="application/json"][data-variant], script[type="application/json"][data-variants]');
    if (vjson) {
      try {
        const parsed = JSON.parse(vjson.textContent.trim());
        const arr = Array.isArray(parsed) ? parsed : (parsed && Array.isArray(parsed.variants) ? parsed.variants : []);
        const first = Array.isArray(arr) ? (arr.find(v => v.available) || arr[0]) : null;
        if (first) return String(first.id);
      } catch {}
    }
    return '';
  }
  async function addViaAjaxAndRefresh(variantId, qty) {
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ id:Number(variantId), quantity:Number(qty) }),
      credentials:'same-origin',
      cache:'no-store'
    });
    if (!addRes.ok) throw new Error('Cart add failed');
    try { document.dispatchEvent(new CustomEvent('cart:open')); } catch {}
    try { window.dispatchEvent(new CustomEvent('cart:open')); } catch {}
    const ids = new Set(['cart-drawer','cart-icon-bubble','mini-cart','header-cart','cart-notification','main-cart-items','cart-items']);
    $$('[id^="shopify-section-"]').forEach(sec=>{
      const id = sec.id.replace('shopify-section-','');
      if (/cart|drawer/i.test(id)) ids.add(id);
    });
    await Promise.all(Array.from(ids).map(async (id)=>{
      try {
        const res = await fetch(`${ROOT}?section_id=${encodeURIComponent(id)}&sections_url=${encodeURIComponent(location.pathname)}`, {
          headers:{'Accept':'text/html,application/xhtml+xml,application/xml'},
          credentials:'same-origin',
          cache:'no-store'
        });
        if (!res.ok) return;
        const html = await res.text();
        const host = document.getElementById(`shopify-section-${id}`) || document.querySelector(`[data-section-id="${id}"]`);
        if (host) host.outerHTML = html;
      } catch {}
    }));
  }
  async function submitViaQuickViewProxy(handle, variantIdOrEmpty, quantity) {
    const { proxy, form } = await ensureProxyQuickView(handle, variantIdOrEmpty || '');
    let variantId = variantIdOrEmpty;
    if (!variantId) variantId = resolveVariantIdFromProxyForm(form);
    if (!variantId) variantId = await fetchDefaultVariantId(handle);
    if (!variantId) throw new Error('Geen variant-id gevonden (product/variant)');
    let idInput = form.querySelector('input[name="id"]');
    if (!idInput) { idInput = document.createElement('input'); idInput.type='hidden'; idInput.name='id'; form.appendChild(idInput); }
    idInput.value = String(variantId);
    let qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) { qtyInput = document.createElement('input'); qtyInput.type='hidden'; qtyInput.name='quantity'; form.appendChild(qtyInput); }
    qtyInput.value = String(Math.max(1, quantity || 1));
    const defaultPrevented = !form.dispatchEvent(new Event('submit', { bubbles:true, cancelable:true }));
    if (!defaultPrevented) {
      await addViaAjaxAndRefresh(variantId, qtyInput.value || 1);
    }
    setTimeout(()=>{ try { proxy.innerHTML=''; } catch{} }, 1000);
  }
  function setLoading(btn, on) {
    if (!btn) return;
    const original = btn.getAttribute('data-original-label') ?? btn.textContent.trim();
    if (!btn.hasAttribute('data-original-label')) btn.setAttribute('data-original-label', original);
    btn.disabled = !!on;
    btn.classList.toggle('loading', !!on);
    if (on) btn.textContent = 'bezig…';
  }
  function flash(btn, text, cls='is-added', ms=1200) {
    if (!btn) return;
    const old = btn.getAttribute('data-original-label') || btn.textContent.trim();
    btn.textContent = text; btn.classList.add(cls);
    setTimeout(()=>{ btn.classList.remove(cls); btn.textContent = old; btn.disabled = false; btn.classList.remove('loading'); }, ms);
  }
  function interceptQuickAdd(e, triggerEl) {
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
    const btn = triggerEl;
    const handle = resolveHandleFromBtn(btn);
    let variantId = resolveVariantIdFromBtn(btn);
    const qtyAttr = (btn.getAttribute('data-quantity') || '').trim();
    const qty = qtyAttr && !isNaN(qtyAttr) ? Math.max(1, parseInt(qtyAttr, 10)) : 1;
    setLoading(btn, true);
    (async () => {
      try {
        if (handle) {
          await submitViaQuickViewProxy(handle, variantId, qty);
        } else if (variantId) {
          await addViaAjaxAndRefresh(variantId, qty);
        } else {
          throw new Error('Geen handle of variant-id gevonden bij quick add');
        }
        flash(btn, 'toegevoegd');
      } catch (err) {
        console.error(err);
        flash(btn, 'mislukt', 'is-error', 2000);
      }
    })();
  }
  // capture phase binding
  window.addEventListener('click', (e) => {
    const el = e.target.closest(QUICK_ADD_SELECTOR);
    if (el) interceptQuickAdd(e, el);
  }, true);
  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const el = e.target.closest(QUICK_ADD_SELECTOR);
    if (el) interceptQuickAdd(e, el);
  }, true);
  window.addEventListener('mousedown', (e) => {
    const el = e.target.closest(QUICK_ADD_SELECTOR);
    if (el) interceptQuickAdd(e, el);
  }, true);
})();
